import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-580e1079"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "overview" };
const _hoisted_2 = { class: "overview__tag" };
const _hoisted_3 = { class: "overview__percentage" };
const _hoisted_4 = { class: "overview__percentage--text" };
const _hoisted_5 = { class: "overview__percentage--highlight" };
const _hoisted_6 = { class: "overview__percentage--text" };
export default /*#__PURE__*/ _defineComponent({
    __name: 'InfluencedRevenue',
    props: {
        impactValues: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('welcome.oto-impact.last-30-days')), 1),
                _createElementVNode("p", _hoisted_3, [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(props.impactValues.revenueOtoPerc?.name), 1),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(props.impactValues.revenueOtoPerc?.value || 0) + "%", 1),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('welcome.oto-impact.total-revenue')), 1)
                ])
            ]));
        };
    }
});
